module.exports = __webpack_public_path__ + "img/GAME_FINDSAMEPICTURE2.5cab4707.jpg";